<template>
    <div v-if="menuItems.length" class="app-wrapper" :class="{ app_wrapper_active: isAppWrapperActive }">
        <div class="navWrapper">
            <div id="menu" :class="{ active: isActive }">
                <el-menu menu-trigger="click" mode="horizontal" :router="true" :default-active="$route.matched[1].path" class="el-menu-demo">
                    <tree-menu v-for="item in menuItems" v-bind:key="item.id" :item="item" @select="select"></tree-menu>
                </el-menu>
            </div>
            <div id="toggle" @click="select()">
                <div class="span" id="top" :class="{ active: isActive }"></div>
                <div class="span" id="middle" :class="{ active: isActive }"></div>
                <div class="span" id="bottom" :class="{ active: isActive }"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import TreeMenu from "./TreeMenu";
    export default {
        components: {
            TreeMenu
        },
        data() {
            return {
                menuItems: [],
                isActive: false,
                isAppWrapperActive: false,
            };
        },
        mounted() {
            serverBus.$on("menuItems", response => {
                this.getMenu()
            });
            this.getMenu()
        },
        computed: {
            hamBurgur: function () {
                return this.$store.state.hamBurgur
            }
        },
        methods: {
            select: function () {
                this.isActive = !this.isActive;
                this.isAppWrapperActive = !this.isAppWrapperActive;
            },
            getMenu() {
                request({
                        url: "get-menu",
                        method: "get",
                        params: {}
                    })
                    .then(response => {
                        this.menuItems = (response) ? response.data.data : {};
                        this.$store.dispatch("setConfig", {
                            menuItems: this.menuItems
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    };

</script>
<style lang="scss">
    .el-aside {
        width: auto !important;
        float: left;
    }

    .el-menu {
        background: transparent !important;
        color: #fff !important;
        flex-shrink: 0;
        flex-direction: column;
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 230px;
    }

    .el-menu--popup {
        background: #fff !important
    }
</style>



// WEBPACK FOOTER //
// src/components/Layout/TopNav/TopNav.vue